import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../../../../common/components/Button';

export default function EnquireInfo({ onClose }) {
  return (
    <div className="text-center">
      <div>
        <b>Thank you!</b>
        <br />
        Your message has been successfully sent and one of our team will be in touch within 24 hours to arrange this.
      </div>
      <br />
      <Button className="-block" onClick={onClose}>
        Close
      </Button>
    </div>
  );
}

EnquireInfo.propTypes = {
  onClose: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/javascript/pro_platform/components/EnquireModal/parts/EnquireInfo/EnquireInfo.js